import { ReceiptApiClient } from "@/clients/receiptApiClient";
import { Receipt, ReceiptStatus } from "@/types/receipt";
import { TransactionSuggestion } from "@/types/payments";

export class ReceiptService {
  private receiptApiClient = new ReceiptApiClient();

  public async fetchReceipts(statusFilter?: ReceiptStatus): Promise<Receipt[]> {
    return this.receiptApiClient.getReceipts(statusFilter);
  }

  public async getReceiptById(receiptId: string): Promise<Receipt> {
    return this.receiptApiClient.getReceiptById(receiptId);
  }

  public async createReceipt(financialDocumentId: string, amount: number, currency: string): Promise<Receipt> {
    return this.receiptApiClient.createReceipt(financialDocumentId, amount, currency);
  }

  public async matchReceipt(receiptId: string, transaction: { id: string; amount: number; currency: string; date: string; bankAccountId: string }): Promise<Receipt> {
    return this.receiptApiClient.matchReceipt(receiptId, transaction);
  }

  public async markAsMatchedExternally(receiptId: string, matchedAt: string, actualSekAmount?: number): Promise<Receipt> {
    return this.receiptApiClient.markAsMatchedExternally(receiptId, matchedAt, actualSekAmount);
  }

  /**
   * Issue #498, Task 5 — the receipt-side equivalent of PaymentService.acknowledgeExternalPayment
   * (case c: bank accounts connected, no matching transaction found, consultant acknowledges the
   * payment was settled outside a connected account). Thin delegation to the API client, same
   * shape as PaymentService.acknowledgeExternalPayment's precedent.
   */
  public async acknowledgeExternalMatch(receiptId: string, matchedAt: string, actualSekAmount?: number): Promise<Receipt> {
    return this.receiptApiClient.acknowledgeExternalMatch(receiptId, matchedAt, actualSekAmount);
  }

  public async getTransactionSuggestions(financialDocumentId: string): Promise<TransactionSuggestion[]> {
    return this.receiptApiClient.getTransactionSuggestions(financialDocumentId);
  }

  public async getPrecomputedTransactionSuggestions(financialDocumentId: string): Promise<TransactionSuggestion[]> {
    return this.receiptApiClient.getPrecomputedTransactionSuggestions(financialDocumentId);
  }
}
